import React, { useEffect, useState } from 'react';
import NativeSelect from '@material-ui/core/NativeSelect';
import Box from '@material-ui/core/Box';

export type ComboBoxItemType = {
  index: number;
  name: string;
};

type Props = {
  itemList: ComboBoxItemType[] | undefined;
  label: string;
  labelPosition?: number;//2 右ラベル表示
  value?: number;
  itemBoxStyle?: string;
  labelStyle?: string;
  onChangeEvent?: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
};

/**
 * コンボボックス ラベルの位置指定可能
 * @param props 
 * @returns 
 */
export const ItemComboBoxAdjLabel: React.FC<Props> = (props) => {
  const { labelPosition = 1 } = props;
  //console.debug(['ItemComboBoxAdjLabel()', props, labelPosition]);

  return (
    <Box display="flex" justifyContent="flex-start" alignItems="center">
      {labelPosition === 1 && <div className={props.labelStyle ?? ''}>{props.label}</div>}
      <div>
        <NativeSelect onChange={props.onChangeEvent} className={props.itemBoxStyle ?? ''} value={props.value}>
          {props.itemList?.map((row, index) => (
            <option key={row.index} value={row.index}>{`${row.name}`}</option>
          ))}
        </NativeSelect>
      </div>
      {labelPosition === 2 && <div> {props.label}</div>}
    </Box>
  );
};
export default ItemComboBoxAdjLabel;
